import React, { useState } from 'react';
import { Sparkles, Zap, Settings, ArrowLeft } from 'lucide-react';
import { ModuleTabs } from './ModuleTabs.jsx';
import { SettingsModal } from './SettingsModal.jsx';
import { ClientSelectorModal } from './ClientSelectorModal.jsx';

export function TopBar({
  activeTab,
  onSelectTab,
  avatarSrc,
  clients = [],
  activeClientId,
  activeClient,
  onSelectClient,
  onCreateClient
}) {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);

  return (
    <>
      <header style={{
        height: '60px',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        background: 'rgba(15, 17, 24, 0.85)',
        backdropFilter: 'blur(12px)',
        zIndex: 40
      }}>
        {/* Brand Title & Active Client Selector */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {/* Botón de Retorno a Cabina Maestra */}
          <a
            href="https://softmatek.com/admin"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              background: 'rgba(56, 189, 248, 0.08)',
              border: '1px solid rgba(56, 189, 248, 0.25)',
              padding: '6px 12px',
              borderRadius: '8px',
              color: '#38bdf8',
              fontSize: '12px',
              fontWeight: 700,
              textDecoration: 'none',
              transition: 'all 0.15s ease'
            }}
          >
            <ArrowLeft size={14} />
            <span>Cabina Maestra</span>
          </a>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #a855f7, #6366f1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 0 12px rgba(168, 85, 247, 0.4)'
            }}>
              <Sparkles size={18} color="#fff" />
            </div>
            <div>
              <div style={{ fontWeight: 800, fontSize: '15px', letterSpacing: '-0.3px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                MAGNIFIC <span style={{ color: '#a855f7', fontWeight: 600 }}>STUDIO</span>
                <span style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '4px', background: 'rgba(168, 85, 247, 0.15)', color: '#c084fc', border: '1px solid rgba(168,85,247,0.3)' }}>VEO 2.0</span>
              </div>
              <div style={{ fontSize: '11px', color: '#64748b' }}>B2B Agency Video Suite</div>
            </div>
          </div>

          {/* Selector Rápido de Empresa Activa */}
          <button
            type="button"
            onClick={() => setIsClientModalOpen(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              background: 'rgba(168, 85, 247, 0.12)',
              border: '1px solid rgba(168, 85, 247, 0.35)',
              padding: '6px 12px',
              borderRadius: '8px',
              color: '#f8fafc',
              fontSize: '12px',
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'all 0.15s ease'
            }}
          >
            <span style={{ color: '#c084fc', fontSize: '11px' }}>🏢 Empresa:</span>
            <strong style={{ color: '#fff' }}>{activeClient?.name || 'Seleccionar...'}</strong>
            <span style={{ fontSize: '10px', color: '#a855f7' }}>▼</span>
          </button>
        </div>

        {/* Tabs */}
        <ModuleTabs activeTab={activeTab} onSelectTab={onSelectTab} />

        {/* Quota, Settings & Profile */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button
            type="button"
            onClick={() => setIsSettingsOpen(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              background: 'rgba(255,255,255,0.04)',
              padding: '6px 12px',
              borderRadius: '8px',
              border: '1px solid rgba(255,255,255,0.08)',
              fontSize: '12px',
              color: '#94a3b8',
              cursor: 'pointer',
              transition: 'all 0.15s ease'
            }}
            title="Configurar motor de IA"
          >
            <Zap size={14} color="#eab308" />
            <span>Google Veo: <strong style={{ color: '#f8fafc' }}>Active</strong></span>
          </button>

          <button
            type="button"
            onClick={() => setIsSettingsOpen(true)}
            style={{
              background: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.08)',
              color: '#cbd5e1',
              padding: '7px',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.15s ease'
            }}
            title="Ajustes y API Keys"
          >
            <Settings size={15} />
          </button>

          <img
            src={avatarSrc}
            alt="Avatar Profile"
            onClick={() => setIsSettingsOpen(true)}
            style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #a855f7', cursor: 'pointer' }}
            title="Perfil de Avatar"
          />
        </div>
      </header>

      <SettingsModal
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
      />

      <ClientSelectorModal
        isOpen={isClientModalOpen}
        onClose={() => setIsClientModalOpen(false)}
        clients={clients}
        activeClientId={activeClientId}
        onSelectClient={onSelectClient}
        onCreateClient={onCreateClient}
      />
    </>
  );
}

